import React, { useEffect, useState } from "react";
import { Card, Col, Container, Form, Row, Table } from "react-bootstrap";
import Scheme from "./Scheme";
import { Button, FormControl, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import { FaPlus, FaTrash } from "react-icons/fa";
import { get_beneficiary_by_id, get_Tds_Section, get_Tds_Rate } from "../../helper/Api";
import {
  check_is_equal_sanctioned_and_schemes_amount,
} from "../../helper/Utils";
import { validateUploadDocument } from "../../helper/uploadValidation";
import { toast } from "react-toastify";

const Invoice = ({
  handleInput,
  formData,
  setFormData,
  handleVendor,
  vendorList,
  vendor,
  voucherIndex,
  invoiceIndex,
  setLoading
}) => {
  const [paymentType, setPaymentType] = useState("");
  const [invoiceNo, setInvoiceNo] = useState("");
  const [invoiceDate, setInvoiceDate] = useState("");
  const [vendorId, setVendorId] = useState(0);
  const [vendorAccountList, setVendorAccountList] = useState([]);
  const [section, setSection] = useState([]);
  const [rate, setRate] = useState([]);

  useEffect(() => {
    fetchSection();
  }, []);

  let data = formData.vouchers[voucherIndex].invoices[invoiceIndex];
  const all_rates = [0, 0.1, 0.5, 0.7, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  const get_rate = (rate) => {
    let taxable_amount =
      formData.vouchers[voucherIndex].invoices[invoiceIndex].taxable_amount;
    if (taxable_amount) {
      let amount = 0;
      amount = (taxable_amount * rate) / 100;
      return Math.round(amount);
    } else {
      return 0;
    }
  };

  const get_labour_amount = (rate) => {
    const invoice_value =
      formData.vouchers[voucherIndex].invoices[invoiceIndex].invoice_value;
    if (invoice_value && rate) {
      return Math.round((invoice_value * rate) / 100);
    }
    return 0;
  };

  const renderDeductionLabel = (title, calculation) => (
    <div>
      <div style={{ fontWeight: 500 }}>{title}</div>
      <small className="text-muted d-block" style={{ fontSize: "11px", marginTop: "2px" }}>
        {calculation}
      </small>
    </div>
  );

  const calculateResult = () => {
    var s_gst = get_rate(data.s_gst_rate);
    var i_gst = get_rate(data.i_gst_rate);
    var c_gst = get_rate(data.c_gst_rate);
    var tds_it;
    if (data.tds_it_rate != "other") {
      tds_it = get_rate(data.tds_it_rate);
    } else {
      tds_it = get_rate(data.tds_it_other_rate);
    }
    var royalty_rate = get_rate(data.royalty_rate);
    var labour_rate = get_labour_amount(data.labour_rate);
    var other = data.other_deduction;
    var gis = data.gis;
    var nps = data.nps;

    if (!other) {
      other = 0;
    } else {
      other = parseInt(other);
    }
    if (!gis) {
      gis = 0;
    } else {
      gis = parseInt(gis);
    }
    if (!nps) {
      nps = 0;
    } else {
      nps = parseInt(nps);
    }

    if (!s_gst) {
      s_gst = 0;
    }
    if (!i_gst) {
      i_gst = 0;
    }
    if (!c_gst) {
      c_gst = 0;
    }
    if (!tds_it) {
      tds_it = 0;
    }
    if (!royalty_rate) {
      royalty_rate = 0;
    }
    if (!labour_rate) {
      labour_rate = 0;
    }
    let total = 0;
    total =
      s_gst +
      i_gst +
      c_gst +
      tds_it +
      other +
      gis +
      nps +
      royalty_rate +
      labour_rate;
    return total;
  };

  const total_payment_amount = () => {
    let total_payable = total_payable_amount();
    let payable_amount =
      parseInt(total_payable) -
      parseInt(data.penalty_amount || 0) -
      parseInt(data.withheld_amount || 0);
    return payable_amount;
  };
  const total_payable_amount = () => {
    const total_deduct = calculateResult();
    let payable_amount = data.sanction_amount
      ? parseInt(data.sanction_amount)
      : 0;
    return payable_amount - total_deduct;
  };

  const addScheme = (v_index, i_index) => {
    setFormData((prevState) => {
      const newVouchers = [...prevState.vouchers];
      const newInvoices = [...newVouchers[v_index].invoices];
      // Lock scheme_id and subhead to match first scheme row
      const firstScheme = newInvoices[i_index].schemes[0];
      const lockedSchemeId = firstScheme?.scheme_id || null;
      const lockedSubheadId = firstScheme?.subheads?.[0]?.sub_heads_id || null;
      newInvoices[i_index].schemes.push({
        scheme_id: lockedSchemeId,
        amount: null,
        subheads: [
          {
            sub_heads_id: lockedSubheadId,
            sub_head_amount: null,
            activity: [
              {
                activity_id: "",
                subactivity_id: "",
                provisional_budget: "",
                budget: "",
                amount: "",
              },
            ],
          },
        ],
      });
      newVouchers[v_index].invoices = newInvoices;
      return { ...prevState, vouchers: newVouchers };
    });
  };

  const fetchVendorAccountList = async (vendorId) => {
    const res = await get_beneficiary_by_id(vendorId);
    if (res.data.status) {
      setVendorAccountList(res.data.list[0].beneficiary_accounts);
    }
  };
  // console.log('vendorAccountList', vendorAccountList);

  const handleInvoiceChange = (e, voucherIndex, invoiceIndex) => {
    let { name, value } = e.target;
    if (name == "vendor_id") {
      handleVendor(e);
      setVendorId(value);
      fetchVendorAccountList(value);
    }
    if (name == "payment") {
      setPaymentType(value);
    }
    if (name == "invoice_no") {
      setInvoiceNo(value);
    }
    if (name == "invoice_date") {
      setInvoiceDate(value);
    }
    if (name == "tds_it_section") {
      fetchRate(value);
    }
    setFormData((prevState) => {
      const newVouchers = [...prevState.vouchers];
      const newInvoices = [...newVouchers[voucherIndex].invoices];
      newInvoices[invoiceIndex][name] = value;

      if (name === "labour_rate" || name === "invoice_value") {
        const invoiceValue =
          name === "invoice_value" ? value : newInvoices[invoiceIndex].invoice_value;
        const labourRate =
          name === "labour_rate" ? value : newInvoices[invoiceIndex].labour_rate;
        newInvoices[invoiceIndex].labour_amount = invoiceValue && labourRate
          ? Math.round((invoiceValue * labourRate) / 100)
          : 0;
      }

      newVouchers[voucherIndex].invoices = newInvoices;
      return { ...prevState, vouchers: newVouchers };
    });
  };

  const handleInvoiceChangeFile = (e, voucherIndex, invoiceIndex) => {
    const { name, files } = e.target;
    const check = validateUploadDocument(files?.[0]);
    if (!check.ok) {
      e.target.value = "";
      toast.error(check.message, {
        position: toast.POSITION.TOP_CENTER,
      });
      return;
    }
    setFormData((prevState) => {
      const newVouchers = [...prevState.vouchers];
      const newInvoices = [...newVouchers[voucherIndex].invoices];
      newInvoices[invoiceIndex][name] = files;
      newVouchers[voucherIndex].invoices = newInvoices;
      return { ...prevState, vouchers: newVouchers };
    });
  };

  const deleteInvoice = (voucherIndex, invoiceIndex) => {
    setFormData((prevState) => {
      const newVouchers = [...prevState.vouchers];
      const newInvoices = [...newVouchers[voucherIndex].invoices];
      newInvoices.splice(invoiceIndex, 1);
      newVouchers[voucherIndex].invoices = newInvoices;
      return { ...prevState, vouchers: newVouchers };
    });
  };
  const validateFloatingPoint = (number) => {
    const regex = new RegExp(`^\\d*\\.?\\d{0,${2}}$`);
    if (!regex.test(number)) {
      toast.error(`The number can only have up to 2 digits after the decimal point.`, {
        position: toast.POSITION.TOP_CENTER,
      });
      return false;
    }
    const floatNumber = parseFloat(number);
    if (floatNumber > 100) {
      toast.error("The number cannot be greater than 100.", {
        position: toast.POSITION.TOP_CENTER,
      });
      return false;
    }
    return true;
  };
  const handleChange = (e, voucherIndex, invoiceIndex) => {
    const value = e.target.value;
    if (validateFloatingPoint(value)) {
      handleInvoiceChange(e, voucherIndex, invoiceIndex);
    }
  };
  const fetchSection = async () => {
    try {
      const resp = await get_Tds_Section();
      if (resp.data.status == true) {
        setSection(resp.data.list);
      }
    } catch (error) {
      setSection([]);
    }
  };
  const fetchRate = async (id) => {
    try {
      const resp = await get_Tds_Rate(id);
      if (resp.data.status == true) {
        setRate(resp.data.list);
      }
    } catch (error) {
      setRate([]);
    }
  };
  return (
    <>
      {invoiceIndex > 0 && (
        <div>
          <button
            className="btn btn-danger btn-sm"
            onClick={() => deleteInvoice(voucherIndex, invoiceIndex)}
          >
            Invoice {invoiceIndex + 1} <FaTrash />
          </button>
        </div>
      )}
      <Container fluid>
        {/*
          NOTE: We store invoice fields inside formData.vouchers[voucherIndex].invoices[invoiceIndex].
          So selects must read value from that nested invoice object (not top-level formData).
        */}
        <Row>
          <Col md={6}>
            <FormControl fullWidth size="small" required sx={{ my: "10px" }}>
              <InputLabel id={`vendor_id_label_${voucherIndex}_${invoiceIndex}`}>
                Vendor
              </InputLabel>
              <Select
                labelId={`vendor_id_label_${voucherIndex}_${invoiceIndex}`}
                id={`vendor_id_${voucherIndex}_${invoiceIndex}`}
                onChange={(e) =>
                  handleInvoiceChange(e, voucherIndex, invoiceIndex)
                }
                name="vendor_id"
                value={
                  formData?.vouchers?.[voucherIndex]?.invoices?.[invoiceIndex]
                    ?.vendor_id != null
                    ? String(
                        formData.vouchers[voucherIndex].invoices[invoiceIndex]
                          .vendor_id,
                      )
                    : ""
                }
                label="Vendor"
              >
                <MenuItem value="">--- Select Vendor ---</MenuItem>
                {vendorList.map((v) => (
                  v.l2_status == 1 &&
                  v.l3_status == 1 ? (
                    <MenuItem value={String(v.id)} key={v.id}>
                      {v.company_name}
                    </MenuItem>
                  ) : null
                ))}
              </Select>
            </FormControl>
          </Col>
          <Col md={6}>
            <FormControl fullWidth size="small" required sx={{ my: "10px" }}>
              <InputLabel id={`vendor_account_id_label_${voucherIndex}_${invoiceIndex}`}>
                Vendor Account
              </InputLabel>
              <Select
                labelId={`vendor_account_id_label_${voucherIndex}_${invoiceIndex}`}
                id={`vendor_account_id_${voucherIndex}_${invoiceIndex}`}
                onChange={(e) =>
                  handleInvoiceChange(e, voucherIndex, invoiceIndex)
                }
                name="vendor_account_id"
                value={
                  formData?.vouchers?.[voucherIndex]?.invoices?.[invoiceIndex]
                    ?.vendor_account_id != null
                    ? String(
                        formData.vouchers[voucherIndex].invoices[invoiceIndex]
                          .vendor_account_id,
                      )
                    : ""
                }
                label="Vendor Account"
              >
                <MenuItem value="">--- Select Beneficiary Account ---</MenuItem>
                {vendorAccountList.map((va) => (
                  va.l2_status == 1 && va.l3_status == 1 ? (
                    <MenuItem value={String(va.id)} key={va.id}>
                      {`${va.beneficiary_name} [${va.account_no}]`}
                    </MenuItem>
                  ) : null
                ))}
              </Select>
            </FormControl>
          </Col>
          <Container fluid>
            <Card className="mb-3 shadow-sm" style={{ border: "1px solid #555" }}>
              <Card.Body className="py-2 px-3">
                <Row className="g-3">
                  <Col md={3}>
                    <div className="text-muted small mb-1">Vendor Code</div>
                    <div className="fw-semibold">
                      {vendor.id ? `B-${vendor.id}` : "-"}
                    </div>
                  </Col>
                  <Col md={3}>
                    <div className="text-muted small mb-1">Contact Person</div>
                    <div className="fw-semibold">
                      {vendor.contact_person ? vendor.contact_person : "-"}
                    </div>
                  </Col>
                  <Col md={3}>
                    <div className="text-muted small mb-1">Mobile</div>
                    <div className="fw-semibold">
                      {vendor.mobile ? vendor.mobile : "-"}
                    </div>
                  </Col>
                  <Col md={3}>
                    <div className="text-muted small mb-1">GSTN No.</div>
                    <div className="fw-semibold">
                      {vendor.gst_no ? vendor.gst_no : "-"}
                    </div>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Container>
          {/* <Col md={6}>
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <Form.Label>
                Payment : <span className="text-danger">*</span>
              </Form.Label>
              <Form.Select
                onChange={(e) =>
                  handleInvoiceChange(e, voucherIndex, invoiceIndex)
                }
                name="payment"
                value={formData.payment_type}
                required
              >
                <option value="1">Full Payment</option>
              </Form.Select>
            </Form.Group>
          </Col> */}
          <Col md={4}>
            <TextField
              fullWidth
              size="small"
              sx={{ my: "5px" }}
              label="Invoice No"
              required
              name="invoice_no"
              value={
                formData?.vouchers?.[voucherIndex]?.invoices?.[invoiceIndex]
                  ?.invoice_no ?? ""
              }
              onChange={(e) =>
                handleInvoiceChange(e, voucherIndex, invoiceIndex)
              }
            />
          </Col>
          <Col md={4}>
            <TextField
              fullWidth
              size="small"
              sx={{ my: "5px" }}
              label="Invoice Date"
              type="date"
              required
              name="invoice_date"
              value={
                formData?.vouchers?.[voucherIndex]?.invoices?.[invoiceIndex]
                  ?.invoice_date ?? ""
              }
              inputProps={{ max: formData.sanction_order_date ?? undefined }}
              InputLabelProps={{ shrink: true }}
              onChange={(e) =>
                handleInvoiceChange(e, voucherIndex, invoiceIndex)
              }
            />
          </Col>
          <Col md={4}>
            <TextField
              fullWidth
              size="small"
              sx={{ my: "5px" }}
              label="Invoice Ref No"
              name="invoice_ref_no"
              value={
                formData?.vouchers?.[voucherIndex]?.invoices?.[invoiceIndex]
                  ?.invoice_ref_no ?? ""
              }
              onChange={(e) =>
                handleInvoiceChange(e, voucherIndex, invoiceIndex)
              }
            />
          </Col>
          <Col md={4}>
            <TextField
              fullWidth
              size="small"
              sx={{ my: "5px" }}
              label="Invoice Value"
              type="number"
              required
              name="invoice_value"
              value={
                formData?.vouchers?.[voucherIndex]?.invoices?.[invoiceIndex]
                  ?.invoice_value ?? ""
              }
              onChange={(e) =>
                handleInvoiceChange(e, voucherIndex, invoiceIndex)
              }
            />
          </Col>
          <Col md={4}>
            <TextField
              fullWidth
              size="small"
              sx={{ my: "5px" }}
              label="Taxable Amount"
              type="number"
              required
              name="taxable_amount"
              value={
                formData?.vouchers?.[voucherIndex]?.invoices?.[invoiceIndex]
                  ?.taxable_amount ??
                formData?.vouchers?.[voucherIndex]?.invoices?.[invoiceIndex]
                  ?.taxable_amuount ??
                ""
              }
              onChange={(e) =>
                handleInvoiceChange(e, voucherIndex, invoiceIndex)
              }
            />
          </Col>
          <Col md={4}>
            <TextField
              fullWidth
              size="small"
              sx={{ my: "5px" }}
              label="Sanctioned Amount"
              type="number"
              required
              name="sanction_amount"
              value={
                formData?.vouchers?.[voucherIndex]?.invoices?.[invoiceIndex]
                  ?.sanction_amount ??
                data?.sanction_amount ??
                ""
              }
              onChange={(e) =>
                handleInvoiceChange(e, voucherIndex, invoiceIndex)
              }
            />
          </Col>
          <Col md={4}>
            <TextField
              fullWidth
              size="small"
              sx={{ my: "5px" }}
              label="GST"
              type="number"
              placeholder="Enter GST"
              name="gst"
              value={
                formData?.vouchers?.[voucherIndex]?.invoices?.[invoiceIndex]
                  ?.gst ?? ""
              }
              onChange={(e) =>
                handleInvoiceChange(e, voucherIndex, invoiceIndex)
              }
            />
          </Col>

          <Col md={4}>
            <TextField
              fullWidth
              size="small"
              sx={{ my: "5px" }}
              label="Sanction / Voucher / Invoice Order (only pdf allowed under 5MB.)"
              type="file"
              name="invoice"
              required
              inputProps={{ accept: ".pdf,.jpeg,.jpg,.png" }}
              InputLabelProps={{ shrink: true }}
              onChange={(e) =>
                handleInvoiceChangeFile(e, voucherIndex, invoiceIndex)
              }
            />
          </Col>

          <Col md={4}>
            <TextField
              fullWidth
              size="small"
              sx={{ my: "5px" }}
              label="Invoice Ref. (only pdf allowed under 5MB.)"
              type="file"
              name="invoice_ref"
              inputProps={{ accept: ".pdf,.jpeg,.jpg,.png" }}
              InputLabelProps={{ shrink: true }}
              onChange={(e) =>
                handleInvoiceChangeFile(e, voucherIndex, invoiceIndex)
              }
            />
          </Col>
          <Container fluid>
            <Table striped bordered>
              <thead className="bg-light">
                <tr>
                  <th>Deduction</th>
                  <th>Rate (%)</th>
                  <th align="right">Amount</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{renderDeductionLabel("TDS (IT)", "Taxable Amount × Rate%")}</td>
                  <td>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        gap: "20px",
                      }}
                    >
                      <Form.Select
                        name="tds_it_section"
                        onChange={(e) =>
                          handleInvoiceChange(e, voucherIndex, invoiceIndex)
                        }
                      >
                        <option value="">---select Section---</option>
                        {section.map((item) => {
                          return (
                            <option value={item?.id} key={item?.id}>
                              {item?.section}
                            </option>
                          );
                        })}
                      </Form.Select>
                      <Form.Select
                        name="tds_it_rate"
                        onChange={(e) =>
                          handleInvoiceChange(e, voucherIndex, invoiceIndex)
                        }
                      >
                        <option value="">---select Rate---</option>
                        {rate.map((item) => (
                          <option value={item?.amount} key={item?.id}>
                            {item?.amount}
                          </option>
                        ))}
                        <option value="other">Other</option>
                      </Form.Select>
                      {formData.vouchers[voucherIndex].invoices[invoiceIndex]
                        .tds_it_rate === "other" && (
                        <Form.Control
                          type="text"
                          placeholder=""
                          name="tds_it_other_rate"
                          onChange={(e) =>
                            handleChange(e, voucherIndex, invoiceIndex)
                          }
                          value={
                            formData.vouchers[voucherIndex].invoices[
                              invoiceIndex
                            ].tds_it_other_rate
                          }
                        />
                      )}
                    </div>
                  </td>
                  <td>
                    {formData.vouchers[voucherIndex].invoices[invoiceIndex]
                      .tds_it_rate === "other"
                      ? get_rate(
                          formData.vouchers[voucherIndex].invoices[invoiceIndex]
                            .tds_it_other_rate,
                        )
                      : get_rate(
                          formData.vouchers[voucherIndex].invoices[invoiceIndex]
                            .tds_it_rate,
                        )}
                    <input
                      type="hidden"
                      name="tds_it_amount"
                      value={
                        formData.vouchers[voucherIndex].invoices[invoiceIndex]
                          .tds_it_rate === "other"
                          ? get_rate(
                              formData.vouchers[voucherIndex].invoices[
                                invoiceIndex
                              ].tds_it_other_rate,
                            )
                          : get_rate(
                              formData.vouchers[voucherIndex].invoices[
                                invoiceIndex
                              ].tds_it_rate,
                            )
                      }
                    />
                  </td>
                </tr>
                <tr>
                  <td>{renderDeductionLabel("TDS (S-GST)", "Taxable Amount × Rate%")}</td>
                  <td>
                    <Form.Select
                      name="s_gst_rate"
                      onChange={(e) =>
                        handleInvoiceChange(e, voucherIndex, invoiceIndex)
                      }
                    >
                      <option value="">---select Rate---</option>
                      {all_rates.map((rate) => {
                        return (
                          <option value={rate} key={rate}>
                            {rate}
                          </option>
                        );
                      })}
                    </Form.Select>
                  </td>
                  <td>
                    {get_rate(
                      formData.vouchers[voucherIndex].invoices[invoiceIndex]
                        .s_gst_rate,
                    )
                      ? get_rate(
                          formData.vouchers[voucherIndex].invoices[invoiceIndex]
                            .s_gst_rate,
                        )
                      : 0}
                    <input
                      type="hidden"
                      name="s_gst_amount"
                      value={
                        get_rate(
                          formData.vouchers[voucherIndex].invoices[invoiceIndex]
                            .s_gst_rate,
                        )
                          ? get_rate(
                              formData.vouchers[voucherIndex].invoices[
                                invoiceIndex
                              ].s_gst_rate,
                            )
                          : 0
                      }
                    />
                  </td>
                </tr>
                <tr>
                  <td>{renderDeductionLabel("TDS (C-GST)", "Taxable Amount × Rate%")}</td>
                  <td>
                    <Form.Select
                      name="c_gst_rate"
                      onChange={(e) =>
                        handleInvoiceChange(e, voucherIndex, invoiceIndex)
                      }
                    >
                      <option value="">---select Rate---</option>
                      {all_rates.map((rate) => {
                        return (
                          <option value={rate} key={rate}>
                            {rate}
                          </option>
                        );
                      })}
                    </Form.Select>
                  </td>
                  <td>
                    {get_rate(data.c_gst_rate) ? get_rate(data.c_gst_rate) : 0}
                    <input
                      type="hidden"
                      name="c_gst_amount"
                      value={
                        get_rate(data.c_gst_rate)
                          ? get_rate(data.c_gst_rate)
                          : 0
                      }
                    />
                  </td>
                </tr>
                <tr>
                  <td>{renderDeductionLabel("TDS (I-GST)", "Taxable Amount × Rate%")}</td>
                  <td>
                    <Form.Select
                      name="i_gst_rate"
                      onChange={(e) =>
                        handleInvoiceChange(e, voucherIndex, invoiceIndex)
                      }
                    >
                      <option value="">---select Rate---</option>
                      {all_rates.map((rate) => {
                        return (
                          <option value={rate} key={rate}>
                            {rate}
                          </option>
                        );
                      })}
                    </Form.Select>
                  </td>
                  <td>
                    {get_rate(data.i_gst_rate) ? get_rate(data.i_gst_rate) : 0}
                    <input
                      type="hidden"
                      name="i_gst_amount"
                      value={
                        get_rate(data.i_gst_rate)
                          ? get_rate(data.i_gst_rate)
                          : 0
                      }
                    />
                  </td>
                </tr>
                
                <tr>
                  <td>{renderDeductionLabel("Royalty", "Taxable Amount × Rate%")}</td>
                  <td>
                    <Form.Select
                      name="royalty_rate"
                      onChange={(e) =>
                        handleInvoiceChange(e, voucherIndex, invoiceIndex)
                      }
                    >
                      <option value="">---select Rate---</option>
                      {all_rates.map((rate) => {
                        return (
                          <option value={rate} key={rate}>
                            {rate}
                          </option>
                        );
                      })}
                    </Form.Select>
                  </td>
                  <td>
                    {get_rate(data.royalty_rate)
                      ? get_rate(data.royalty_rate)
                      : 0}
                    <input
                      type="hidden"
                      name="royalty_amount"
                      value={
                        get_rate(data.royalty_rate)
                          ? get_rate(data.royalty_rate)
                          : 0
                      }
                    />
                  </td>
                </tr>
                <tr>
                  <td>{renderDeductionLabel("Labour Cess", "Invoice Value × Rate%")}</td>
                  <td>
                    <Form.Select
                      name="labour_rate"
                      onChange={(e) =>
                        handleInvoiceChange(e, voucherIndex, invoiceIndex)
                      }
                    >
                      <option value="">---select Rate---</option>
                      {all_rates.map((rate) => {
                        return (
                          <option value={rate} key={rate}>
                            {rate}
                          </option>
                        );
                      })}
                    </Form.Select>
                  </td>
                  <td>
                    {get_labour_amount(data.labour_rate)
                      ? get_labour_amount(data.labour_rate)
                      : 0}
                    <input
                      type="hidden"
                      name="labour_amount"
                      value={
                        get_labour_amount(data.labour_rate)
                          ? get_labour_amount(data.labour_rate)
                          : 0
                      }
                    />
                  </td>
                </tr>
                <tr>
                  <td>{renderDeductionLabel("Other Deduction", "Fixed Amount")}</td>
                  <td>
                    <Form.Control
                      type="text"
                      placeholder="Enter Deduction Remarks"
                      onChange={(e) =>
                        handleInvoiceChange(e, voucherIndex, invoiceIndex)
                      }
                      name="deduction_remarks"
                    />
                  </td>
                  <td>
                    <input
                      type="number"
                      className="form-control"
                      value={formData.otherDeduction}
                      placeholder="₹ Enter other deduction"
                      onChange={(e) =>
                        handleInvoiceChange(e, voucherIndex, invoiceIndex)
                      }
                      name="other_deduction"
                    />
                  </td>
                </tr>
              </tbody>
            </Table>
          </Container>
          <hr />
          <div className="total_amount_wrapper" style={{ marginLeft: "160px" }}>
            <table
              style={{
                width: "100%",
                padding: "0",
                margin: "0",
                textAlign: "right",
                borderCollapse: "collapse",
                border: "1px solid #E4E5E9", // Added border color to the table
              }}
            >
              <thead></thead>
              <tbody>
                <tr>
                  <td
                    style={{
                      padding: "10px",
                      textAlign: "center",
                      border: "1px solid #E4E5E9", // Added border color to the body cells
                    }}
                  >
                    <h6
                      style={{
                        fontWeight: "bold",
                        fontSize: "16px",
                        textAlign: "center",
                      }}
                    >
                      Sanctioned Amount:
                    </h6>
                  </td>
                  <td style={{ padding: "10px", border: "1px solid #E4E5E9" }}>
                    {" "}
                    {/* Added border color to the body cells */}
                    <b>
                      ₹{" "}
                      {Number(data.sanction_amount).toLocaleString("en-IN", {
                        minimumFractionDigits: 2,
                      })}
                    </b>
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      padding: "10px",
                      textAlign: "center",
                      border: "1px solid #E4E5E9", // Added border color to the body cells
                    }}
                  >
                    <h6
                      style={{
                        fontWeight: "bold",
                        fontSize: "16px",
                        textAlign: "center",
                      }}
                    >
                      Total Deduction:
                    </h6>
                  </td>
                  <td style={{ padding: "10px", border: "1px solid #E4E5E9" }}>
                    {" "}
                    {/* Added border color to the body cells */}
                    <b>
                      ₹{" "}
                      {calculateResult().toLocaleString("en-IN", {
                        minimumFractionDigits: 2,
                      })}
                    </b>
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      padding: "10px",
                      textAlign: "center",
                      border: "1px solid #E4E5E9", // Added border color to the body cells
                    }}
                  >
                    <h6
                      style={{
                        fontWeight: "bold",
                        fontSize: "16px",
                        textAlign: "center",
                      }}
                    >
                      Net Payable Amount:
                    </h6>
                  </td>
                  <td style={{ padding: "10px", border: "1px solid #E4E5E9" }}>
                    {" "}
                    {/* Added border color to the body cells */}
                    <b>
                      ₹{" "}
                      {total_payable_amount().toLocaleString("en-IN", {
                        minimumFractionDigits: 2,
                      })}
                    </b>
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      padding: "10px",
                      textAlign: "center",
                      border: "1px solid #E4E5E9", // Added border color to the body cells
                    }}
                  >
                    <Form.Label
                      style={{ fontWeight: "bold", fontSize: "18px" }}
                    >
                      Penalty:
                    </Form.Label>
                  </td>
                  <td style={{ padding: "10px", border: "1px solid #E4E5E9" }}>
                    {" "}
                    {/* Added border color to the body cells */}
                    <Form.Control
                      type="number"
                      placeholder=""
                      name="penalty_amount"
                      onChange={(e) =>
                        handleInvoiceChange(e, voucherIndex, invoiceIndex)
                      }
                      value={formData.penalty_amount}
                    />
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      padding: "10px",
                      textAlign: "center",
                      border: "1px solid #E4E5E9", // Added border color to the body cells
                    }}
                  >
                    <Form.Label
                      style={{ fontWeight: "bold", fontSize: "18px" }}
                    >
                      Withheld Amount:
                    </Form.Label>
                  </td>
                  <td style={{ padding: "10px", border: "1px solid #E4E5E9" }}>
                    {" "}
                    {/* Added border color to the body cells */}
                    <Form.Control
                      type="number"
                      placeholder=""
                      name="withheld_amount"
                      onChange={(e) =>
                        handleInvoiceChange(e, voucherIndex, invoiceIndex)
                      }
                      value={formData.withheld_amount}
                    />
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      padding: "10px",
                      textAlign: "center",
                      border: "1px solid #E4E5E9", 
                    }}
                  >
                    <h6
                      style={{
                        fontWeight: "bold",
                        fontSize: "16px",
                        textAlign: "center",
                      }}
                    >
                      Net Payment Amount:
                    </h6>
                  </td>
                  <td style={{ padding: "10px", border: "1px solid #E4E5E9" }}>
                    {" "}
                 
                    <b>
                      ₹{" "}
                      {total_payment_amount().toLocaleString("en-IN", {
                        minimumFractionDigits: 2,
                      })}
                    </b>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <Col md={2}>
            <h6>Remarks :</h6>
          </Col>
          <Col md={10}>
            <textarea
              name="remarks"
              id=""
              rows="5"
              onChange={(e) =>
                handleInvoiceChange(e, voucherIndex, invoiceIndex)
              }
              className="form-control"
              placeholder="Enter Remarks"
            ></textarea>
          </Col>
          {formData.vouchers[voucherIndex].invoices[invoiceIndex].schemes.map(
            (scheme, i) => {
              return (
                <>
                  <Scheme
                    handleInput={handleInput}
                    formData={formData}
                    setFormData={setFormData}
                    voucherIndex={voucherIndex}
                    invoiceIndex={invoiceIndex}
                    schemeIndex={i}
                    payable={total_payment_amount()}
                    setLoading={setLoading}
                  />
                </>
              );
            },
          )}
          <div className="m-2">
            {check_is_equal_sanctioned_and_schemes_amount(
              formData.vouchers[voucherIndex].invoices[invoiceIndex]
                .sanction_amount,
              formData.vouchers[voucherIndex].invoices[invoiceIndex].schemes,
            ) ? (
              ""
            ) : (
              <Button
                variant="outlined"
                onClick={() => addScheme(voucherIndex, invoiceIndex)}
              >
                <FaPlus />
                &nbsp;Add FY
              </Button>
            )}
            <br />
          </div>
        </Row>
      </Container>
    </>
  );
};

export default Invoice;
